import { render, staticRenderFns } from "./SocialLearningOverflowMenuSearchResult.vue?vue&type=template&id=6c3b7688&scoped=true&"
import script from "./SocialLearningOverflowMenuSearchResult.vue?vue&type=script&lang=js&"
export * from "./SocialLearningOverflowMenuSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./SocialLearningOverflowMenuSearchResult.vue?vue&type=style&index=0&id=6c3b7688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b7688",
  null
  
)

export default component.exports